import classnames from 'classnames';
import {SlickWrapper} from 'epic-react-common';
import PropTypes from 'prop-types';
import React from 'react';

import PrimalSlide from '../../chapter2/s6/PrimalSlide';
import VideoOverlay from '../../common/VideoOverlay';

import CarouselCenterImage from './CarouselCenterImage';
import CarouselDefault from './CarouselDefault';

export default class Carousel extends React.PureComponent {
  static propTypes = {
    slides: PropTypes.array,
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
    isAndroid: PropTypes.bool,
  };

  state = {
    showVideo: false,
    videoId: '',
  };

  showVideo = (videoId) => {
    this.setState({
      showVideo: true,
      videoId,
    });
  };

  closeOverlay = () => {
    this.setState({
      showVideo: false,
      videoId: '',
    });
  };

  render() {
    const {slides = [], mobile, tablet, isAndroid} = this.props;
    const list = [];
    const singleSlide = slides.length === 1;

    for (let i = 0; i < slides.length; i++) {
      const slide = slides[i];
      const key = `item-${i}`;
      const {type} = slide;
      switch (type) {
        case 'ch2s6':
          list.push(<PrimalSlide slide={slide} key={key} />);
          break;
        case 'ch2s6-lara':
          list.push(<PrimalSlide slide={slide} key={key} className="lara-croft-slide" />);
          break;
        case 'centerimage':
          list.push(
            <CarouselCenterImage
              slide={slide}
              key={key}
              showVideo={this.showVideo}
              mobile={mobile}
              tablet={tablet}
              isAndroid={isAndroid}
            />
          );
          break;
        default:
          //continue;
          list.push(
            <CarouselDefault
              slide={slide}
              key={key}
              showVideo={this.showVideo}
              mobile={mobile}
              tablet={tablet}
              isAndroid={isAndroid}
            />
          );
      }
    }

    const sliderOptions = {
      adaptiveHeight: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      dotsClass: 'carousel-dots bottom',
      arrows: false,
      draggable: false,
      swipeToSlide: true,
      swipe: true,
      touchMove: true,
      fade: false,
      pauseOnHover: false,
    };
    return (
      <div id="mainCarousel" className={classnames({'solo-slider': singleSlide})}>
        <SlickWrapper options={sliderOptions}>{list}</SlickWrapper>
        {this.state.videoId && (
          <VideoOverlay
            videoID={this.state.videoId}
            isLauncher={false}
            play={this.state.showVideo}
            close={this.closeOverlay}
            closeButton
            show={this.state.showVideo}
          />
        )}
      </div>
    );
  }
}
